import { Component, OnInit } from '@angular/core';
import { AdminServiceService } from '../../service/admin-service.service';
import { environment } from 'src/environments/environment';
import { ToastService } from 'src/app/generales/services/toast.service';
import { ModalController } from '@ionic/angular';
import { ModalShopsComponent } from '../modal-shops/modal-shops.component';
import { UiService } from '../../service/ui.service';
import { StoresComponent } from '../stores/stores.component';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss'],
})
export class PaymentsComponent implements OnInit {
  title = 'Pagos';
  data: any;
  pag = 1;
  pagSyze = 10;
  search = 'todos';
  date = 'mas-recientes';
  state = '';
  lastPage: number;
  total: number;
  url: string = environment.url;
  uploading = false;

  constructor(
    private req: AdminServiceService,
    private modalCtrl: ModalController,
    private toastService: ToastService,
    private uiSv: UiService
  ) {}

  ngOnInit() {
    this.loadData();
  }
  async loadData() {
    this.req
      .getPayments(this.pag, this.pagSyze, this.search, this.date, this.state)
      .subscribe((res: any) => {
        this.data = res.data.data;
        console.log(this.data);

        this.lastPage = res.data.meta.last_page;
        this.total = res.data.meta.total;
      });
  }
  filtrar(value) {
    return !value.includes('id_');
  }

  async approved(m, i, index) {
    this.uploading = true;
    const dat = {
      id: m,
    };
    this.req.approvedMethod(dat).subscribe((res: any) => {
      if (res.status) {
        this.data[i].method[index].approved = 1;
        this.uploading = false;
      }
      this.toastService.show(res.data);
    });
  }

  openStore(user) {
    this.uiSv.createModal(StoresComponent, { user }, '');
  }

  async toUser(id) {
    this.req.showUser(id).subscribe(async (res: any) => {
      const m = res.data;
      const modal = await this.modalCtrl.create({
        component: ModalShopsComponent,
        cssClass: 'modal-blog-comentarios',
        componentProps: { shop: m },
      });
      modal.present();
    });
  }
  async showMethod(id) {
    this.req.showMethod(id).subscribe(async (res: any) => {
      const m = res.data;
      const modal = await this.modalCtrl.create({
        component: ModalShopsComponent,
        cssClass: 'modal-blog-comentarios',
        componentProps: { shop: m },
      });
      modal.present();
    });
  }
  calDif(data) {
    const totalAP = data.transaction?.amount;
    let pago = 0;
    for (const element of data.method) {
      if (element.approved) {
        pago = pago + element.amount;
      }
    }
    return totalAP - pago || 0;
  }

  async changePag(i) {
    if (i) {
      this.pag = this.pag + 1;
    } else {
      if (this.pag === 1) {
        return;
      }
      this.pag = this.pag - 1;
    }
    this.loadData();
  }
}
